<template>
	<div class="stories-menu-wrapper">
		<div
			class="header-stories__item"
			v-for="(story, index) in stories"
			:key="story.id"
		>
			<div
				class="stories-menu-slider__item"
				:style="{ backgroundImage: 'url(' + story.preview + ')' }"
				@click="openStory(index)"
			></div>
			<!-- <p>{{ story.name }}</p> -->
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
	computed: {
		...mapState({
			stories: state => state.news.stories
		}),
	},

	methods: {
		...mapActions({
			fetchStories: 'news/fetchStories'
		}),

		...mapMutations({
			setStoryIndex: 'news/setStoryIndex',
			showStory: 'news/showStory'
		}),

		openStory(index) {
			this.setStoryIndex(index)
			this.showStory(true)
		}
	}
};
</script>

<style lang="scss" scoped>
.stories-menu-wrapper {
	padding-bottom: 12px;
	display: flex;
	width: 100%;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 40px;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	scrollbar-width: thin;
	-ms-overflow-style: -ms-autohiding-scrollbar;

	@media only screen and (max-width: 1024px) {
		gap: 24px;
	}

	@media only screen and (max-width: 425px) {
		gap: 18px;
	}
}

.stories-menu-slider {
	overflow: visible;

	&__item {
		width: 140px;
		height: 140px;
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		border-radius: 50%;
		cursor: pointer;

		& img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}

		&-title {
			font-size: 20px;

			@media only screen and (max-width: 767px) {
				font-size: 16px;
			}
		}

		@media only screen and (max-width: 1024px) {
			width: 120px;
			height: 120px;
		}

		@media only screen and (max-width: 425px) {
			width: 100px;
			height: 100px;
		}
	}

}

.header-stories {
	&__item {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}
}
</style>